<template>
  <div class="form-wrap">
    <div class="form-container">
      <el-form
        :model="form"
        ref="form"
        v-loading="loading"
        label-width="auto"
        :rules="rules"
        class="wg-product-ruleForm"
        label-position="top"
        :disabled="submitting"
      >
        <FormBlock name="基本信息">
          <el-row :gutter="10">
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item label="英文名称" prop="name_en" class="base-input">
                <el-input
                  v-model="form.name_en"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item label="中文名称" prop="name_cn" class="base-input">
                <el-input
                  v-model="form.name_cn"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item label="编号" prop="code" class="base-input">
                <el-input
                  v-model="form.code"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item label="联长" prop="length_desc" class="base-input">
                <el-input
                  v-model="form.length_desc"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item
                label="价格（美元）"
                prop="price"
                class="base-input"
              >
                <el-input
                  v-model="form.price"
                  type="number"
                  clearable
                  placeholder="请输入"
                  ><template slot="prepend">$</template></el-input
                >
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item
                label="pieces_per_carton"
                prop="price"
                class="base-input"
              >
                <el-input
                  v-model="form.pieces_per_carton"
                  type="number"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item
                label="sqm_per_carton"
                prop="price"
                class="base-input"
              >
                <el-input
                  v-model="form.sqm_per_carton"
                  type="number"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item
                label="kgs_per_carton"
                prop="price"
                class="base-input"
              >
                <el-input
                  v-model="form.kgs_per_carton"
                  type="number"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item
                label="cartons_per_pallet"
                prop="price"
                class="base-input"
              >
                <el-input
                  v-model="form.cartons_per_pallet"
                  type="number"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item
                label="系列"
                prop="series_ids"
                class="custom-form-select"
              >
                <BasicAsyncSelect
                  multiple
                  keyName="name_cn"
                  valueName="id"
                  v-model="form.series_ids"
                  :filterKeyName="{
                    disabled: false,
                  }"
                  customKeyName
                  :keyNames="['name_cn', 'name_en']"
                  :asyncObj="{
                    dataFun: GetMosaicSeriesList,
                  }"
                />
              </el-form-item>
            </el-col>

            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item
                label="材质"
                prop="material_ids"
                class="custom-form-select"
              >
                <BasicAsyncSelect
                  multiple
                  keyName="name_cn"
                  valueName="id"
                  v-model="form.material_ids"
                  :filterKeyName="{
                    disabled: false,
                  }"
                  customKeyName
                  :keyNames="['name_cn', 'name_en']"
                  :asyncObj="{
                    dataFun: GetMosaicMaterialsList,
                  }"
                />
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item
                label="厚度"
                prop="height_ids"
                class="custom-form-select"
              >
                <BasicAsyncSelect
                  multiple
                  keyName="name_cn"
                  valueName="id"
                  v-model="form.height_ids"
                  :filterKeyName="{
                    disabled: false,
                  }"
                  customKeyName
                  :keyNames="['name_cn', 'name_en']"
                  :asyncObj="{
                    dataFun: GetMosaicHeightsList,
                  }"
                />
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item
                label="工艺"
                prop="technique_ids"
                class="custom-form-select"
              >
                <BasicAsyncSelect
                  multiple
                  keyName="name_cn"
                  valueName="id"
                  v-model="form.technique_ids"
                  :filterKeyName="{
                    disabled: false,
                  }"
                  customKeyName
                  :keyNames="['name_cn', 'name_en']"
                  :asyncObj="{
                    dataFun: GetMosaicTechniquesList,
                  }"
                />
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8" class="custom-form-select">
              <el-form-item label="规格" prop="specification_ids">
                <BasicAsyncSelect
                  multiple
                  keyName="name_cn"
                  valueName="id"
                  v-model="form.specification_ids"
                  :filterKeyName="{
                    disabled: false,
                  }"
                  customKeyName
                  :keyNames="['name_cn', 'name_en']"
                  :asyncObj="{
                    dataFun: GetMosaicSpecificationsList,
                  }"
                />
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8" class="custom-form-select">
              <el-form-item label="风格" prop="style_ids">
                <BasicAsyncSelect
                  multiple
                  keyName="name_cn"
                  valueName="id"
                  v-model="form.style_ids"
                  :filterKeyName="{
                    disabled: false,
                  }"
                  customKeyName
                  :keyNames="['name_cn', 'name_en']"
                  :asyncObj="{
                    dataFun: GetMosaicStylesList,
                  }"
                />
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8" class="custom-form-select">
              <el-form-item label="色系" prop="color_ids">
                <BasicAsyncSelect
                  multiple
                  keyName="name_cn"
                  valueName="id"
                  v-model="form.color_ids"
                  :filterKeyName="{
                    disabled: false,
                  }"
                  customKeyName
                  :keyNames="['name_cn', 'name_en']"
                  :asyncObj="{
                    dataFun: GetMosaicColorsList,
                  }"
                />
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item label="次序（数值越大越靠前）" prop="seq">
                <el-input type="number" v-model="form.seq" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item label="推荐" prop="star">
                <el-switch
                  v-model="form.star"
                  active-text="推荐产品"
                  inactive-text="常规产品"
                >
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item label="首页展示" prop="show_on_index">
                <el-switch
                  v-model="form.show_on_index"
                  active-text="首页展示"
                  inactive-text="非首页展示"
                >
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
        </FormBlock>

        <FormBlock name="封面/海报/图片集">
          <el-row :gutter="10">
            <!-- <el-col :span="6">
              <el-form-item label="缩略图" prop="thumbnail_url">
                <SingleImgUpload v-model="form.thumbnail_url" />
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="封面图" prop="cover_image_url">
                <SingleImgUpload v-model="form.cover_image_url" />
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="false">
              <el-form-item label="效果图" prop="rendering_image_url">
                <SingleImgUpload v-model="form.rendering_image_url" />
              </el-form-item>
            </el-col>

            <!-- <el-col :span="6">
              <el-form-item label="海报图" prop="poster_image_url">
                <SingleImgUpload v-model="form.poster_image_url" />
              </el-form-item>
            </el-col> -->

            <!-- <el-col :span="12">
              <el-form-item label="海报标语" prop="poster_slogan">
                <el-input
                  v-model="form.poster_slogan"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="24" v-if="false">
              <el-form-item label="元素图(显示顺序从左到右)" prop="medias">
                <DraggbleSort
                  syncSortKey
                  v-model="form.element_medias"
                  class="medias-list-wrap"
                >
                  <template v-slot:default="slotProps">
                    <ProductImgUpload
                      v-if="slotProps.item.typeId == 'IMAGE'"
                      class="medias-item"
                      tips="选择图片"
                      v-model="slotProps.item.url"
                      @remove="removeElementMedias(slotProps.index)"
                    />
                    <div
                      class="video-medias-item"
                      v-if="slotProps.item.typeId == 'VIDEO'"
                    >
                      <ProductImgUpload
                        class="medias-item"
                        tips="选择封面图"
                        v-model="slotProps.item.cover_image_url"
                        @remove="clearElementMediasVideoCover(slotProps.index)"
                      />

                      <ProductVideoItem
                        v-if="slotProps.item.typeId == 'VIDEO'"
                        :showDeleteIcon="false"
                        class="medias-item"
                        v-model="slotProps.item.url"
                      />

                      <i
                        class="el-icon-delete remove-video-icon"
                        title="点击删除"
                        @click="removeElementMedias(slotProps.index)"
                      ></i>
                    </div>
                  </template>
                </DraggbleSort>
                <div class="add-madias-item">
                  <el-button-group>
                    <el-button
                      type="primary"
                      size="small"
                      icon="el-icon-picture-outline"
                      @click="addElementMedias('IMAGE')"
                      >添加图片</el-button
                    >
                    <!-- <el-button
                      type="primary"
                      size="small"
                      @click="addElementMedias('VIDEO')"
                      >添加视频<i
                        class="el-icon-video-camera-solid el-icon--right"
                      ></i
                    ></el-button> -->
                  </el-button-group>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="实拍图(显示顺序从左到右)" prop="photos">
                <DraggbleSort
                  syncSortKey
                  v-model="form.photos"
                  class="medias-list-wrap"
                >
                  <template v-slot:default="slotProps">
                    <ProductImgUpload
                      v-if="slotProps.item.typeId == 'IMAGE'"
                      class="medias-item"
                      tips="选择图片"
                      v-model="slotProps.item.url"
                      @remove="removePhotos(slotProps.index)"
                    />
                    <div
                      class="video-medias-item"
                      v-if="slotProps.item.typeId == 'VIDEO'"
                    >
                      <ProductImgUpload
                        class="medias-item"
                        tips="选择封面图"
                        v-model="slotProps.item.cover_image_url"
                        @remove="clearPhotosVideoCover(slotProps.index)"
                      />

                      <ProductVideoItem
                        v-if="slotProps.item.typeId == 'VIDEO'"
                        :showDeleteIcon="false"
                        class="medias-item"
                        v-model="slotProps.item.url"
                      />

                      <i
                        class="el-icon-delete remove-video-icon"
                        title="点击删除"
                        @click="removePhotos(slotProps.index)"
                      ></i>
                    </div>
                  </template>
                </DraggbleSort>
                <div class="add-madias-item">
                  <el-button-group>
                    <el-button
                      type="primary"
                      size="small"
                      icon="el-icon-picture-outline"
                      @click="addPhotos('IMAGE')"
                      >添加图片</el-button
                    >
                    <!-- <el-button
                      type="primary"
                      size="small"
                      @click="addPhotos('VIDEO')"
                      >添加视频<i
                        class="el-icon-video-camera-solid el-icon--right"
                      ></i
                    ></el-button> -->
                  </el-button-group>
                </div>
                <!-- <ProductMediaUpload /> -->
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="false">
              <el-form-item
                label="媒体数据集合(显示顺序从左到右)"
                prop="medias"
              >
                <DraggbleSort
                  syncSortKey
                  v-model="form.normal_medias"
                  class="medias-list-wrap"
                >
                  <template v-slot:default="slotProps">
                    <ProductImgUpload
                      v-if="slotProps.item.typeId == 'IMAGE'"
                      class="medias-item"
                      v-model="slotProps.item.url"
                      @remove="removeMedias(slotProps.index)"
                    />
                    <div
                      v-if="slotProps.item.typeId == 'VIDEO'"
                      class="video-medias-item"
                    >
                      <ProductVideoItem
                        :showDeleteIcon="false"
                        class="medias-item"
                        v-model="slotProps.item.url"
                      />
                      <ProductImgUpload
                        class="medias-item"
                        tips="选择图片"
                        v-model="slotProps.item.cover_image_url"
                        @remove="clearVideoCover(slotProps.index)"
                      />
                      <i
                        class="el-icon-delete remove-video-icon"
                        title="点击删除"
                        @click="removeMedias(slotProps.index)"
                      ></i>
                    </div>
                  </template>
                </DraggbleSort>
                <div class="add-madias-item">
                  <el-button-group>
                    <el-button
                      type="primary"
                      size="small"
                      icon="el-icon-picture-outline"
                      @click="addMedias('IMAGE')"
                      >添加图片</el-button
                    >
                    <!-- <el-button
                      type="primary"
                      size="small"
                      @click="addMedias('VIDEO')"
                      >添加视频<i
                        class="el-icon-video-camera-solid el-icon--right"
                      ></i
                    ></el-button> -->
                  </el-button-group>
                </div>
                <!-- <ProductMediaUpload /> -->
              </el-form-item>
            </el-col>
          </el-row>
        </FormBlock>
        <!-- <FormBlock name="产品简介">
          <el-form-item prop="introduction" v-if="showRichEditor">
            <Tinymce v-model="form.introduction" :height="400" />
          </el-form-item>
        </FormBlock> -->
        <FormBlock name="产品图文详情">
          <el-form-item prop="description" v-if="showRichEditor">
            <Tinymce v-model="form.description" :height="800" />
          </el-form-item>
        </FormBlock>
      </el-form>
    </div>
    <div class="control-btn-group">
      <el-button
        @click="onCancel"
        v-if="isEmprty(this.currentId)"
        :disabled="submitting"
        >重 置</el-button
      >
      <el-button
        v-if="isEmprty(this.currentId)"
        type="primary"
        :loading="submitting"
        @click="submitForm('form')"
        >保存新增</el-button
      >
      <el-button
        v-if="!isEmprty(this.currentId)"
        type="warning"
        :loading="submitting"
        @click="submitEditForm('form')"
        >保存修改</el-button
      >
    </div>
  </div>
</template>

<script>
import { isEmprty } from "@/utils/validate";
import { createUniqueString, compare } from "@/utils/common";
import {
  PostMosaicProducts,
  PutMosaicProductsById,
  GetMosaicProductsById,
} from "../api";
import { ShowApiError } from "@/request/error";
// import BasicSelect from "@/components/BasicSelect";
import DraggbleSort from "@/components/DraggbleSort";
import SingleImgUpload from "@/components/SingleImgUpload";
// import ImgUpload from "@/components/ImgUpload/ImgUpload";
import FormBlock from "@/components/FormBlock";
import Tinymce from "@/components/Tinymce";
import ProductVideoItem from "@/components/ProductVideoItem";
import ProductImgUpload from "@/components/ProductImgUpload";
import BasicAsyncSelect from "@/components/BasicAsyncSelect";
import { GetMosaicColorsList } from "@/views/productColors/api";
import { GetMosaicMaterialsList } from "@/views/productMaterials/api";
import { GetMosaicSpecificationsList } from "@/views/productSpecifications/api";
import { GetMosaicStylesList } from "@/views/productStyles/api";
import { GetMosaicTechniquesList } from "@/views/productTechniques/api";
import { GetMosaicSeriesList } from "@/views/productSeries/api";
import { GetMosaicHeightsList } from "@/views/productHeights/api";
export default {
  name: "ProductForm",
  props: {
    productId: {
      type: [String, Number],
      default: null,
    },
  },
  components: {
    FormBlock,
    SingleImgUpload,
    BasicAsyncSelect,
    // ImgUpload,
    // BasicSelect,
    Tinymce,
    DraggbleSort,
    ProductVideoItem,
    ProductImgUpload,
  },
  data() {
    return {
      currentId: null,
      loading: false,
      submitting: false,
      showAddMediaDialog: false,
      showRichEditor: true,
      focusIndex: 0,
      form: {},
      rules: {
        name_en: [
          { required: true, message: "请输入英文名称", trigger: "blur" },
        ],
        name_cn: [
          { required: true, message: "请输入中文名称", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    productId: {
      handler(value) {
        if (!isEmprty(value)) {
          this.currentId = value;
          this.getFormData();
        } else {
          this.currentId = null;
          this.initForm();
        }
      },
      immediate: true,
    },
  },
  created() {
    this.initForm();
  },
  methods: {
    isEmprty,
    createUniqueString,
    GetMosaicColorsList,
    GetMosaicMaterialsList,
    GetMosaicSpecificationsList,
    GetMosaicStylesList,
    GetMosaicTechniquesList,
    GetMosaicSeriesList,
    GetMosaicHeightsList,
    formatForm() {
      return {
        ...this.form,
        code: this.form.code == "" ? null : this.form.code,
        photos: this.form.photos.map((item) => {
          return {
            cover_image_url: item.cover_image_url,
            typeId: item.typeId,
            seq: item.seq,
            url: item.url,
          };
        }),
        normal_medias: this.form.normal_medias.map((item) => {
          return {
            cover_image_url: item.cover_image_url,
            typeId: item.typeId,
            seq: item.seq,
            url: item.url,
          };
        }),
        element_medias: this.form.element_medias.map((item) => {
          return {
            cover_image_url: item.cover_image_url,
            typeId: item.typeId,
            seq: item.seq,
            url: item.url,
          };
        }),
      };
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitting = true;
          PostMosaicProducts([this.formatForm()])
            .then(() => {
              this.submitting = false;
              this.initForm();

              this.$message.success("新增成功");
              this.$emit("success");
            })
            .catch((err) => {
              this.submitting = false;
              ShowApiError(err, "批量新增异常");
            });
        } else {
          this.$message.warning("表单有误，请检查");
          return false;
        }
      });
    },
    submitEditForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitting = true;
          PutMosaicProductsById(this.currentId, this.formatForm())
            .then(() => {
              this.submitting = false;
              this.$message.success("修改成功");
              this.$emit("success");
            })
            .catch((err) => {
              this.submitting = false;
              ShowApiError(err, "批量新增异常");
            });
        } else {
          this.$message.warning("表单有误，请检查");
          return false;
        }
      });
    },
    getFormData() {
      this.loading = true;
      GetMosaicProductsById(this.currentId)
        .then((res) => {
          let _data = res.data;
          this.initForm();
          this.reviewFormByData(_data);
          this.showRichEditor = true;
          this.loading = false;
        })

        .catch((err) => {
          this.loading = false;
          ShowApiError(err, "获取表单数据失败");
        });
    },
    reviewFormByData(_data = {}) {
      this.form = {
        code: _data.code,
        name_cn: _data.name_cn,
        name_en: _data.name_en,
        length_desc: _data.length_desc,
        price: _data.price,
        pieces_per_carton: _data.pieces_per_carton,
        sqm_per_carton: _data.sqm_per_carton,
        kgs_per_carton: _data.kgs_per_carton,
        cartons_per_pallet: _data.cartons_per_pallet,
        introduction: _data.introduction,
        description: _data.description,
        photos: this.sortArr(_data.photos),
        element_medias: this.sortArr(_data.element_medias),
        normal_medias: this.sortArr(_data.normal_medias),
        material_ids: this.formatDataToids(_data.materials),
        technique_ids: this.formatDataToids(_data.techniques),
        specification_ids: this.formatDataToids(_data.specifications),
        style_ids: this.formatDataToids(_data.styles),
        color_ids: this.formatDataToids(_data.colors),
        series_ids: this.formatDataToids(_data.series),
        height_ids: this.formatDataToids(_data.heights),
        thumbnail_url: _data.thumbnail_url,
        rendering_image_url: _data.rendering_image_url,
        cover_image_url: _data.cover_image_url,
        poster_image_url: _data.poster_image_url,
        poster_slogan: _data.poster_slogan,
        seq: _data.seq,
        star: _data.star,
        show_on_index: _data.show_on_index,
      };
    },
    sortArr(data = []) {
      if (data.length <= 0) {
        return data;
      }
      return data.sort(compare("seq"));
    },
    formatDataToids(data = []) {
      if (data.length <= 0) {
        return data;
      }
      return data.map((item) => item.id);
    },
    initForm() {
      this.form = {
        code: null,
        name_cn: "",
        name_en: "",
        length_desc: "",
        price: null,
        pieces_per_carton: null,
        sqm_per_carton: null,
        kgs_per_carton: null,
        cartons_per_pallet: null,
        introduction: "",
        description: "",
        poster_image_url: "",
        poster_slogan: "",
        cover_image_url: "",
        rendering_image_url: "",
        thumbnail_url: "",
        star: false,
        show_on_index: false,
        seq: 0,
        normal_medias: [],
        element_medias: [],
        photos: [],
        material_ids: [],
        technique_ids: [],
        specification_ids: [],
        style_ids: [],
        color_ids: [],
        series_ids: [],
        height_ids: [],
      };
      this.resetRichComponent();
      this.$nextTick(() => {
        if (this.$refs["form"]) {
          this.$refs["form"].clearValidate();
        }
      });
    },
    resetRichComponent() {
      this.showRichEditor = false;
      let timer = null;
      timer = setTimeout(() => {
        clearTimeout(timer);
        this.showRichEditor = true;
      }, 1000);
    },

    // 媒体
    addMedias(type) {
      let item = {
        cover_image_url: "",
        seq: this.form.normal_medias.length,
        typeId: type,
        url: "",
      };
      this.form.normal_medias.push(item);
    },
    removeMedias(index) {
      this.form.normal_medias.splice(index, 1);
    },

    clearVideoCover(index) {
      this.form.normal_medias = this.form.normal_medias.map((m, i) => {
        if (i == index) {
          m.cover_image_url = "";
        }
        return m;
      });
    },
    // 元素图
    addElementMedias(type) {
      let item = {
        cover_image_url: "",
        seq: this.form.element_medias.length,
        typeId: type,
        url: "",
      };
      this.form.element_medias.push(item);
    },
    removeElementMedias(index) {
      this.form.element_medias.splice(index, 1);
    },
    clearElementMediasVideoCover(index) {
      this.form.element_medias = this.form.element_medias.map((m, i) => {
        if (i == index) {
          m.cover_image_url = "";
        }
        return m;
      });
    },
    // 实拍图
    addPhotos(type) {
      let item = {
        cover_image_url: "",
        seq: this.form.photos.length,
        typeId: type,
        url: "",
      };
      this.form.photos.push(item);
    },
    removePhotos(index) {
      this.form.photos.splice(index, 1);
    },
    clearPhotosVideoCover(index) {
      this.form.photos = this.form.photos.map((m, i) => {
        if (i == index) {
          m.cover_image_url = "";
        }
        return m;
      });
    },
    onCancel() {
      this.initForm();
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="scss" scoped>
.wg-product-ruleForm {
  box-sizing: border-box;
  width: 100%;
  .icon-btn {
    font-size: 20px;
    padding: 5px 10px;
    cursor: pointer;
  }
  .base-input {
    ::v-deep {
      .el-form-item__content {
        height: 40px;
        overflow: hidden;
      }
      .el-input__inner {
        height: 40px;
      }
    }
  }
}
.form-tips {
  font-size: 13px;
  text-align: left;
  padding: 10px;
}
.box-card {
  margin-bottom: 10px;
  &:hover {
    background-color: #f1f1f1;
  }
}
.medias-list-wrap {
  display: inline-block;
  max-width: 100%;
  ::v-deep {
    .transition-el {
      max-height: none;
    }
  }
  .medias-item {
    display: block;
    width: 100px;
    height: 100px;
    margin: 5px;
  }
  .video-medias-item {
    box-sizing: border-box;
    padding: 5px 0;
    margin: 5px;
    width: 280px;
    height: 100px;
    position: relative;
    padding-right: 20px;
    background-color: #ddd;
    border: 1px solid #ddd;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .remove-video-icon {
      position: absolute;
      bottom: 5px;
      right: 2px;
      font-size: 16px;
      cursor: pointer;
      color: #c51515;
    }
    ::v-deep {
      .basic-upload-wrap {
        width: 150px;
        height: 90px;
      }
      .img-upload-wrap {
        width: 90px;
        height: 90px;
      }
    }
  }
}
.add-madias-item {
  display: block;
  width: 100%;
  height: 40px;
  font-size: 30px;
  margin: 0 5px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
}
.models-list-wrap {
  width: 100%;
  max-width: 100%;
  .box-card {
    width: auto;
    cursor: move;
  }
  ::v-deep {
    .transition-el {
      box-sizing: border-box;
      flex-direction: row;
      max-height: 100%;
    }
  }
}

.form-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  .custom-form-select {
    ::v-deep {
      .el-form-item__content {
        max-height: 40px;
      }
    }
  }

  .form-container {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding-bottom: 70px;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .control-btn-group {
    box-sizing: border-box;
    width: 100%;
    background-color: #fff;
    padding: 10px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0;
    z-index: 2006;
    text-align: right;
  }
}
</style>
